export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7361_FOCUS': 'Focus',
    '_11130_COPY_MESSAGE': 'Copy Message',
    '_11131_DELETE_MESSAGE': 'Delete Message',
    '_11036_ENTER_YOUR_TEXT': 'Enter your text',
    '_11037_ADD_NOTES': 'Add Notes',
    '_11132_CREATE_COACHING_NOTES_FROM_CHAT_CONVERSATION': 'Create coaching notes from chat conversation',
    '_11133_REPLY': 'Reply',
    '_11134_SELECT_YOUR_EMOJI': 'Select your emoji',
    '_11135_CLOSE_WINDOW': 'Close window',
    '_11136_EXPAND_WINDOW': 'Expand Window',
    '_11137_COLLAPSE_WINDOW': 'Collapse Window',
    '_11138_COMMITMENT_MUST_BE_ACTIVE_OR_DRAFT': 'Commitment must be Active or Draft'
};
